// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3g368","icon":"styles_icon__23x_3"};